<template>
    <span>
        <span v-if="name === 'simple-description'">
            <span v-if="hasTypePlusSubtype">{{ typePlusSubtype }},</span>
            <span v-if="hasRooms">{{ rooms }} -</span>
            <span v-if="hasPrice">
                <humanized-money :value="price"></humanized-money>
            </span>
        </span>
        <span v-if="name === 'address'">
            {{ addressLine }}
        </span>
    </span>
</template>

<script>
    const { plural } = require('sci/utils')

    export default {
        props: {
            name: {
                required: true,
                type: String
            },
            property: {
                required: true,
                type: Object
            }
        },
        name: 'property-lines',
        computed: {
            addressLine () {
                const { street, streetNumber, complementary, floor, neighborhood, alternativeNeighborhood, city } = this.property;
                const addressValues = []

                if (street) {
                    addressValues.push(street)
                }

                const streetNumberValues = []

                if (streetNumber) {
                    streetNumberValues.push(`nº ${streetNumber}`)
                }

                if (complementary) {
                    streetNumberValues.push(complementary)
                }

                if (streetNumberValues.length) {
                    addressValues.push(streetNumberValues.join(' - '))
                }

                if (floor) {
                    addressValues.push(`${floor}º andar`)
                }

                const locationValues = []

                if (alternativeNeighborhood) {
                    locationValues.push(alternativeNeighborhood.name)
                } else if (neighborhood) {
                    locationValues.push(neighborhood.name)
                }

                if (city) {
                    locationValues.push(city.name)
                }

                if (!addressValues.length) {
                    if (locationValues.length) {
                        return locationValues.join(' - ')
                    }

                    return null
                }

                const result = [...addressValues, ...locationValues];

                let line = result.join(', ')

                if (city && city.state) {
                    line += ` - ${city.state.abbreviation}`
                }

                return line || null;
            },
            hasTypePlusSubtype () {
                return this.property.typeInfo || this.property.subtypeInfo
            },
            typePlusSubtype () {
                const res = [];

                if (this.property.typeInfo) {
                    res.push(this.property.typeInfo.name)
                }

                if (this.property.subtypeInfo) {
                    res.push(this.property.subtypeInfo.name)
                }

                return res.join(' - ')
            },
            hasRooms () {
                return this.property.dormCount || this.property.carGarageCount
            },
            rooms () {
                const res = [];

                if (this.property.dormCount) {
                    res.push(plural(this.property.dormCount, '%s dorm', '%s dorms'))
                }

                if (this.property.carGarageCount) {
                    res.push(plural(this.property.carGarageCount, '%s vagas', '%s vagas'))
                }

                return res.join(', ')
            },
            hasPrice () {
                return this.property.forSale || this.property.forRent || this.property.forVacation || this.property.forLease
            },
            price () {
                let price = 0.0

                if (this.property.forSale || this.property.forLease) {
                    price = this.property.sellPrice || 0.0
                } else {
                    price = this.property.rentPrice || 0.0
                }

                return price
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Line.vue?6d96abb9